(()=>{'use strict';
const init=()=>{
 const dropdown=document.querySelector('[data-d9-dropdown]');
 if(dropdown&&!dropdown.dataset.ready){
  dropdown.dataset.ready='true';
  const trigger=dropdown.querySelector('[data-d9-dropdown-trigger]');
  const panel=dropdown.querySelector('.d9-labs-menu');
  const scrim=dropdown.querySelector('[data-d10-close]');
  const setOpen=open=>{panel.hidden=!open;if(scrim)scrim.hidden=!open;trigger.setAttribute('aria-expanded',String(open))};
  const close=()=>setOpen(false);
  trigger.addEventListener('click',()=>setOpen(trigger.getAttribute('aria-expanded')!=='true'));
  scrim?.addEventListener('click',close);
  dropdown.addEventListener('keydown',event=>{
   if(event.key==='Escape'){close();if(matchMedia('(max-width:1023px)').matches)document.querySelector('[data-r-menu]')?.focus();else trigger.focus()}
   if(event.key==='ArrowDown'&&event.target===trigger){event.preventDefault();setOpen(true);panel.querySelector('a')?.focus()}
  });
  document.addEventListener('click',event=>{
   if(!dropdown.contains(event.target))close();
  });
  dropdown.addEventListener('focusout',event=>{if(event.relatedTarget&&!dropdown.contains(event.relatedTarget))close()});
  panel.querySelectorAll('a').forEach(link=>{if(new URL(link.href).pathname===location.pathname)link.setAttribute('aria-current','page');link.addEventListener('click',()=>{close();document.querySelector('#r-nav')?.classList.remove('r-open');document.querySelector('[data-r-menu]')?.setAttribute('aria-expanded','false');document.querySelector('[data-r-menu]')?.setAttribute('aria-label','Menü öffnen')})});
  matchMedia('(min-width:1024px)').addEventListener('change',close);
 }
 document.querySelectorAll('[data-d10-accordion]').forEach(group=>{
  if(group.dataset.ready)return;group.dataset.ready='true';
  const items=[...group.querySelectorAll('details')];
  items.forEach(item=>item.addEventListener('toggle',()=>{if(item.open)items.forEach(other=>{if(other!==item)other.open=false})}));
  const target=items.find(item=>'#'+item.id===location.hash);if(target)target.open=true;
 });
 const contact=document.querySelector('#r-contact');
 if(contact&&!contact.dataset.ready){
  contact.dataset.ready='true';
  const select=contact.querySelector('[data-d11-contact-reason]');
  const message=contact.querySelector('textarea');
  const buttons=[...document.querySelectorAll('[data-d11-reason]')];
  const toggle=(selector,show)=>{const el=contact.querySelector(selector);if(!el)return;el.hidden=!show;el.querySelectorAll('input').forEach(input=>input.disabled=!show)};
  const sync=()=>{const value=select.value;toggle('[data-d11-business]',['gastro','retail','wedding','events'].includes(value));toggle('[data-d11-event]',(value==='events'||value==='wedding'));buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.d11Reason===value)));const key=value==='retail'?'gastro':value==='wedding'?'events':value;if(message.dataset[key])message.placeholder=message.dataset[key]};
  if(select&&message){select.addEventListener('change',sync);buttons.forEach(button=>button.addEventListener('click',()=>{select.value=button.dataset.d11Reason;sync();select.focus({preventScroll:true})}));sync()}
 }

};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',init);
})();
